var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvBoltHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216,
    height: 107,
    viewBox: "0 0 216 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 216,
    height: 107,
    transform: "translate(2212.14 295)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-2212.14 -295)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flash",
    transform: "translate(2239.123 250.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M145.652,122.2,88.557,104.743,118.092,8.1,11.94,119.718l57.095,17.455L39.5,233.816Z",
    transform: "translate(-11.94 1.087)",
    fill: "#fff",
    opacity: 0.404
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M103.973,40.642,85.6,100.079l-2.664,8.773,8.773,2.664,42.9,13.091-68.9,72.666,18.373-59.438,2.664-8.773L77.929,126.4l-42.9-13.091,68.9-72.666M124.138,6.1,17.94,117.718l57.095,17.455L45.5,231.632,151.7,120.014,94.6,102.56,124.138,6.1Z",
    transform: "translate(9.62 -6.1)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvBoltHeader);
export default __webpack_public_path__ + "static/media/ev_bolt_header.758be8ee8399c339979d61a54466af05.svg";
export { ForwardRef as ReactComponent };